module.exports = __webpack_public_path__ + "static/media/sync.4456b946.svg";